module.exports = __webpack_public_path__ + "img/unicorn-book_B097DCBNLX.4c8a66e9.jpg";